const resolveHostname = () => {
  if (typeof window !== 'undefined' && window.location.hostname) {
    return window.location.hostname;
  }
  return '127.0.0.1';
};

const isLocalHost = (hostname) =>
  hostname === 'localhost' || hostname === '127.0.0.1';

const isPrivateLanHost = (hostname) => {
  if (isLocalHost(hostname)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  return false;
};

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE.replace(/\/$/, '');
  }

  // CRA dev proxy (package.json) forwards /helport_api -> local PHP backend.
  // Relative URL works from localhost and from a phone on the same Wi‑Fi (e.g. 192.168.x.x:3002).
  if (process.env.NODE_ENV === 'development') {
    return '/helport_api';
  }

  const hostname = resolveHostname();
  const protocol =
    typeof window !== 'undefined' ? window.location.protocol : 'http:';

  if (isPrivateLanHost(hostname)) {
    return `${protocol}//${hostname}/helport_api`;
  }

  return `${protocol}//${hostname}`;
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api.php`;

export const buildApiUrl = (action, base = API_BASE_URL) => {
  const encodedAction = encodeURIComponent(action);
  return base.endsWith('/api.php')
    ? `${base}?action=${encodedAction}`
    : `${base}/api.php?action=${encodedAction}`;
};

export const getUploadUrl = (filename) =>
  `${API_BASE_URL}/uploads/${encodeURIComponent(filename)}`;

export const getHelportBrandLogoUrl = () =>
  `${API_BASE_URL}/api.php?action=brand_logo`;

export const getHelportBrandFaviconUrl = () =>
  `${API_BASE_URL}/api.php?action=brand_mark_svg`;

export const getHelportBrandMarkUrl = () =>
  `${API_BASE_URL}/api.php?action=brand_mark_svg`;
